import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconInfo: OSKIconDefinition = {
  name: 'info',
  content: '<circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" />'
};
